import CityServicePage from "@/pages/city-service/CityServicePage";
import { etobicokeAcRepair } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={etobicokeAcRepair} />; }
